import type { PropsWithChildren } from 'react';
import { FormattedMessage } from 'react-intl';

type BackButtonProps = PropsWithChildren & {
    href: string;
};

const BackButton = (props: BackButtonProps) => {
    const { children = <FormattedMessage id='intl-msg:orderexchange.navigation.backToOverview' />, href } = props;

    return (
        <div className='display-flex align-items-center'>
            <span className='rioglyph rioglyph-chevron-left text-color-primary' />
            <a href={href}>
                <span className='margin-left-5'>{children}</span>
            </a>
        </div>
    );
};

export default BackButton;
